export const pushFunnelEvent = (eventName: string, params?: Record<string, unknown>) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: eventName,
        ...params,
    });
};

export const trackFunnelStart = (entryMethod: "predicted" | "manual") => {
    pushFunnelEvent("funnel_step_start", {
        funnel_step: 1,
        funnel_step_name: "funnel_start",
        address_entry_method: entryMethod,
    });
};

export const trackSolarMapContinued = (markerAdjusted: boolean) => {
    pushFunnelEvent("funnel_step_solar_map", {
        funnel_step: 2,
        funnel_step_name: "address_check",
        marker_adjusted: markerAdjusted,
    });
};

export const trackDetailsSubmitted = (householdSize: string, powerConsumption: number) => {
    pushFunnelEvent("funnel_step_details", {
        funnel_step: 3,
        funnel_step_name: "details_input",
        household_size: householdSize,
        power_consumption: powerConsumption,
    });
};
